import { Button } from '@/lib';
import React, { FC } from 'react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';

type ActionButtonProps = {
  onEdit: () => void;
  onDelete?: () => void;
};

export const ActionButton: FC<ActionButtonProps> = ({ onEdit, onDelete }) => {
  return (
    <div className='flex items-center gap-2'>
      <Button
        type='button'
        intent='link-color'
        aria-label='Edit template'
        title='Edit template'
        onClick={(event) => {
          event.stopPropagation();
          onEdit();
        }}
      >
        <FiEdit2 className='size-4' />
      </Button>
      {onDelete ? (
        <Button
          type='button'
          intent='tertiary'
          className='text-red-600 hover:text-red-800'
          aria-label='Delete template'
          title='Delete template'
          onClick={(event) => {
            event.stopPropagation();
            onDelete();
          }}
        >
          <FiTrash2 className='size-4' />
        </Button>
      ) : null}
    </div>
  );
};
